import * as yup from 'yup'
import { IAnimal } from 'src/dto/animal.dto'

export const createAnimalSchema = yup.object().shape({
  tipoAnimal: yup.string().nullable().typeError('Selecione uma das opções.'),
  sexo: yup.string().required('Sexo é obrigatório.'),
  dataNascimento: yup.string().required('Data de nascimento é obrigatório.'),
  cdn: yup.string().required('Número é obrigatório.'),
  fazendaOrigem: yup
    .string()
    .when('tipoAnimal', {
      is: 'animal_comprado',
      then: (schema) => schema.required('Fazenda de origem é obrigatória.'),
      otherwise: (schema) => schema.notRequired()
    })
    .nullable()
})

export const createBasicAnimalSchema = yup.object().shape({
  sexo: yup.string().required('Sexo é obrigatório.'),
  cdn: yup.string().required('Número é obrigatório.'),
  dataNascimento: yup.string().required('Data de nascimento é obrigatório.')
})

export const weightSchema = yup.object({
  idAnimal: yup.string().required('Animal é obrigatório').defined(),
  tipoPesagem: yup.string().oneOf(['pesagem', 'pesagem_fita']).required('Tipo de pesagem é obrigatório.').defined(),
  peso: yup
    .string()
    .transform((value) => (value ? value.replace(/[^\d,]/g, '').replace(',', '.') : value))
    .when('tipoPesagem', {
      is: 'pesagem',
      then: (schema) => schema.required('Peso é obrigatório.'),
      otherwise: (schema) => schema.nullable()
    }),
  perimetro: yup
    .string()
    .transform((value) => (value ? value.replace(/[^\d,]/g, '').replace(',', '.') : value))
    .when('tipoPesagem', {
      is: 'pesagem',
      then: (schema) => schema.required('Perímetro é obrigatório.'),
      otherwise: (schema) => schema.nullable()
    }),
  fitaPerimetro: yup
    .string()
    .transform((value) => (value ? value.replace(/[^\d,]/g, '').replace(',', '.') : value))
    .when('tipoPesagem', {
      is: 'pesagem_fita',
      then: (schema) => schema.required('Perímetro torácico é obrigatório.'),
      otherwise: (schema) => schema.nullable()
    })
    .nullable(),
  fitaComprimento: yup
    .string()
    .transform((value) => (value ? value.replace(/[^\d,]/g, '').replace(',', '.') : value))
    .when('tipoPesagem', {
      is: 'pesagem_fita',
      then: (schema) => schema.required('Comprimento da ponta da espádua à ponta da nádega é obrigatório.'),
      otherwise: (schema) => schema.nullable()
    })
})

export const movimentationSchema = yup.object({
  tipoMovimentacao: yup.string().oneOf(['animal', 'lote']).required('Tipo de movimentação é obrigatório.').defined(),
  animals: yup
    .array()
    .of(yup.string().required())
    .ensure()
    .when('tipoMovimentacao', {
      is: 'lote',
      then: (schema) =>
        schema.min(1, 'Lote sem animais para movimentação').required('Lote sem animais para movimentação.'),
      otherwise: (schema) => schema.nullable().default([])
    }),
  idAnimal: yup.string().when('tipoMovimentacao', {
    is: 'animal',
    then: (schema) => schema.required('Animal é obrigatório'),
    otherwise: (schema) => schema.nullable()
  }),

  loteOrigem: yup.string().nullable().default(null),
  loteDestino: yup.string().required('Lote de destino é obrigatório.'),
  pastoOrigem: yup.string().nullable().default(null),
  pastoDestino: yup.string().nullable().default(null)
})

export const healthControlSchema = yup.object({
  tipoControle: yup.string().oneOf(['animal', 'lote']).required('Tipo de controle é obrigatório.').defined(),
  idAnimal: yup
    .string()
    .when('tipoControle', {
      is: 'animal',
      then: (schema) => schema.required('Animal é obrigatório'),
      otherwise: (schema) => schema.nullable()
    })
    .nullable(),
  animais: yup
    .array()
    .of(yup.string().required())
    .ensure()
    .when('tipoControle', {
      is: 'lote',
      then: (schema) =>
        schema.min(1, 'Lote sem animais para movimentação').required('Lote sem animais para movimentação.'),
      otherwise: (schema) => schema.nullable().default([])
    }),
  idLote: yup
    .string()
    .when('tipoControle', {
      is: 'lote',
      then: (schema) => schema.required('Lote é obrigatório'),
      otherwise: (schema) => schema.nullable()
    })
    .nullable(),
  dataAplicacao: yup.string().required('Data de Aplicação é obrigatória.').defined(),
  vacinas: yup.array().of(yup.string().required('Vacina é obrigatória.')).ensure().nullable()
})

export type CreateAnimalForm = Partial<IAnimal> & { tourosMulti?: boolean }
export type CreateBasicAnimalForm = yup.InferType<typeof createBasicAnimalSchema> & Partial<IAnimal>
export type CreateWeightForm = yup.InferType<typeof weightSchema>

export type updateAnimalAnimalForm = Partial<IAnimal>

export type MovimentationForm = yup.InferType<typeof movimentationSchema>
export type HealthControlForm = yup.InferType<typeof healthControlSchema>
